import type { CardRate } from "@/features/card/api/types";

export type RateGroup = {
	percent: number;
	positions: string[];
};

/** Figma sections: highest % first. Zero / missing rates stay out. */
export function groupRatesByPercent(rates: CardRate[]): RateGroup[] {
	const byPercent = new Map<number, string[]>();

	for (const rate of rates) {
		if (rate.percent <= 0) {
			continue;
		}
		const list = byPercent.get(rate.percent) ?? [];
		list.push(rate.position);
		byPercent.set(rate.percent, list);
	}

	return [...byPercent.entries()]
		.sort((a, b) => b[0] - a[0])
		.map(([percent, positions]) => ({ percent, positions }));
}
